import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Chatbot from "components/Chatbot";
import TopRotatingBanner from "components/TopRotatingBanner";
import Home from "pages/Home";
import Product from "pages/Product";
import Services from "pages/Services";
import WebDevelopment from "pages/WebDevelopment";
import MobileAppDevelopment from "pages/MobileAppDevelopment";
import AIIntegration from "pages/AIIntegration";
import CloudDevOps from "pages/CloudDevOps";
import UIUXDesign from "pages/UIUXDesign";
import BackendDevelopment from "pages/BackendDevelopment";
import AIMLServices from "pages/AIMLServices";
import MachineLearning from "pages/MachineLearning";
import NaturalLanguageProcessing from "pages/NaturalLanguageProcessing";
import ComputerVision from "pages/ComputerVision";
import PredictiveAnalytics from "pages/PredictiveAnalytics";
import AIChatbots from "pages/AIChatbots";
import DeepLearning from "pages/DeepLearning";
import DataScience from "pages/DataScience";
import AIConsulting from "pages/AIConsulting";
import ReinforcementLearning from "pages/ReinforcementLearning";
import WorkflowAutomation from "pages/WorkflowAutomation";
import N8nAutomation from "pages/N8nAutomation";
import ZapierIntegration from "pages/ZapierIntegration";
import MakeAutomation from "pages/MakeAutomation";
import AboutUs from "pages/AboutUs";
import ContactUs from "pages/ContactUs";
import Privacy from "pages/Privacy";
import Terms from "pages/Terms";
import BlogListing from "pages/BlogListing";
import NotFound from "pages/NotFound";
import LandingPage from "pages/LandingPage";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <TopRotatingBanner />
        <Chatbot />
        <RouterRoutes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/services/ai-integration" element={<AIIntegration />} />
          <Route path="/services/cloud-devops" element={<CloudDevOps />} />
          <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/services/backend-development" element={<BackendDevelopment />} />
          <Route path="/ai-ml-services" element={<AIMLServices />} />
          <Route path="/services/ai-ml-services/machine-learning" element={<MachineLearning />} />
          <Route path="/services/ai-ml-services/natural-language-processing" element={<NaturalLanguageProcessing />} />
          <Route path="/services/ai-ml-services/computer-vision" element={<ComputerVision />} />
          <Route path="/services/ai-ml-services/predictive-analytics" element={<PredictiveAnalytics />} />
          <Route path="/services/ai-ml-services/ai-chatbots" element={<AIChatbots />} />
          <Route path="/services/ai-ml-services/deep-learning" element={<DeepLearning />} />
          <Route path="/services/ai-ml-services/data-science" element={<DataScience />} />
          <Route path="/services/ai-ml-services/ai-consulting" element={<AIConsulting />} />
          <Route path="/services/ai-ml-services/reinforcement-learning" element={<ReinforcementLearning />} />
          <Route path="/services/workflow-automation" element={<WorkflowAutomation />} />
          <Route path="/services/n8n-automation" element={<N8nAutomation />} />
          <Route path="/services/zapier-integration" element={<ZapierIntegration />} />
          <Route path="/services/make-automation" element={<MakeAutomation />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogListing />} />
          <Route path="/landingpage" element={<LandingPage />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;